import { render, staticRenderFns } from "./Titlebar.vue?vue&type=template&id=79818108&scoped=true"
import script from "./Titlebar.vue?vue&type=script&lang=js"
export * from "./Titlebar.vue?vue&type=script&lang=js"
import style0 from "./Titlebar.vue?vue&type=style&index=0&id=79818108&prod&scoped=true&lang=css"
import style1 from "./Titlebar.vue?vue&type=style&index=1&id=79818108&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79818108",
  null
  
)

export default component.exports